import VueNotification from '@mathieustan/vue-notification';
require('@/assets/css/notification.css')

export default {
  install(Vue) {
    Vue.use(VueNotification);
    Vue.prototype.$msg = {
      success(msg){
        Vue.prototype.$notify({type: 'success', message:msg, showClose: true});
      },
      error(msg){
        Vue.prototype.$notify({type: 'error', message:msg, showClose: true, closeDelay: 9000});
      },
      warning(msg){
        Vue.prototype.$notify({type: 'warning', message:msg, showClose: true});
      }
    }
  }
};
